module.exports = {"question":"Hast du einen Bonus Code?","hint":"","yes":"Ja","no":"Nein","placeholder":"Gib deinen Bonus Code ein","floating":"Bonus Code","expired":"Der Bonus Code ist abgelaufen","invalid":"Bonus Code ist nicht vorhanden","error_hint":"Bitte mit einem anderen Code versuchen oder ohne Bonus Code vortsetzen"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/promoCode.json
// module id = 515
// module chunks = 248 1672